import { apiInstance } from 'api/utils';

export default {
  getBenchmarks: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/benchmarks/'
    });
  },
  getBenchmarkConfig: () => {
    return apiInstance.request({
      method: 'get',
      url: '/benchmarks'
    });
  },
  updateBenchmarksConfig: (data: number[]) => {
    return apiInstance.request({
      method: 'post',
      url: '/benchmarks',
      data: { benchmarks: data }
    });
  },
  getMorningstarBenchmarks: () => {
    return apiInstance.request({
      method: 'get',
      url: '/morningstar-benchmarks'
    });
  },
  getMorningstarBenchmarkConfig: () => {
    return apiInstance.request({
      method: 'get',
      url: '/firm/morningstar-benchmarks/'
    });
  },
  getFixedBenchmarks: (portfolio: any) => {
    return apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/fixed-benchmarks/`
    });
  },
  updateCaseBenchmarks: (portfolio: any, benchmarks: any) => {
    return apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/fixed-benchmarks/`,
      data: { benchmarks }
    });
  },
  getAnalysisFixedBenchmarks: (id: any) => {
    return apiInstance.request({
      method: 'GET',
      url: `/research-item/${id}/fixed-benchmarks`
    });
  },
  updateAnalysisFixedBenchmarks: (id: any, benchmarks: any) => {
    return apiInstance.request({
      method: 'POST',
      url: `/research-item/${id}/fixed-benchmarks`,
      data: { benchmarks }
    });
  }
};
